/**
 * The two frontends this application serves. They run on separate hostnames
 * and share one API; which of them a user may enter comes from the backend
 * (`portals` on the current user).
 *
 * Identity lives here rather than in the theme: the theme is one consumer of
 * it, the router is another.
 */
export const PORTAL = {
  SCHADENPORTAL: "schadenportal",
  KUNDENPORTAL: "kundenportal",
};
